<template>
  <div :class="[$style.field, $style.booleanField]">
    <span :class="$style.label">
      {{ entity.label }}
      <i v-if="required">*</i>
    </span>
    <toggle-button
      :id="id"
      v-model="value"
      :disabled="readonly"
      color="#24f7db"
    ></toggle-button>
    <p v-show="error && showError">{{ error }}</p>
  </div>
</template>

<script>
import Field from "./field";

export default {
  mixins: [Field],
  data() {
    return {
      value: this.entity.field.defaultValue === "true",
    };
  },
};
</script>

<style module lang="less" src="./boolean-field.less"></style>



// WEBPACK FOOTER //
// boolean-field.vue?05a579ed